import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, resetPage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {showModal} from "../actions/modal";
import {loadWalk} from '../actions/walks';
import {defaultState as entityDefaultState} from '../reducers/entity';
import WalkDetail from '../components/walk/WalkDetail';
import {breadcrumbs, Date, Grid, setPageTitle} from "../utils";
import {loadPartyInfo} from "../actions/parties";
import {loadDogInfo} from "../actions/dogs";

class WalkDetailPage extends Component {

	constructor(props) {
		super(props);

		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);

		this.state = {
			party: null,
			dog: null
		};
	}

	componentWillMount() {
		this.loadWalk(this.props.match.params.walkId);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.walkId !== this.props.match.params.walkId
			|| (nextProps.match.params.tab === 'detail' && this.props.match.params.tab !== 'detail')) {
			this.loadWalk(nextProps.match.params.walkId);
		}
	}

	loadWalk(walkId) {
		this.setState({party: false, dog: false});
		this.props.loadWalk(walkId).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const w = json.response.data;
				this.props.loadPartyInfo(w.partyId).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.setState({party: json.response.data});
					}
				});
				this.props.loadDogInfo(w.dogId).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.setState({dog: json.response.data});
					}
				});
			}
		})
	}

	componentWillUnmount() {
		this.props.resetEntity("walk");
		this.props.resetPage("walks");
		setPageTitle();
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleTabSelect(tab) {
		this.props.history.push('/vychazky/' + this.props.match.params.walkId + '/' + tab)
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;
		const {party, dog} = this.state;

		if (entity.isFetchingItem || entity.item === null || party === false || dog === false) {
			return Grid.renderIsFetchingData()
		}

		const tab = params.tab || 'detail';

		const bc = [
			{url: '/vychazky', title: 'Vycházky'},
			{
				url: '/vychazky/' + params.walkId, title: entity && entity.item && entity.item.walkId
					? (
						(party ? party.lastName + ' ' + party.firstName : "?")
						+ " a " +
						(dog ? dog.name : "?")
						+ " " + Date.formatDate(entity.item.walkDate)
					)
					: '...', literal: true
			}
		];
		if (tab !== 'detail') {
			bc.push({url: '/vychazky/' + params.walkId + '/' + tab, title: tab});
		}
		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<WalkDetail {...entity} party={this.state.party} dog={this.state.dog}
					enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onShowModal={this.props.showModal}/>
			</div>
		)
	}
}

WalkDetailPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadWalk: PropTypes.func.isRequired,
	loadPartyInfo: PropTypes.func.isRequired,
	loadDogInfo: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	resetEntity: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {walks},
		enums,
		session
	} = state;

	const entity = walks[ownProps.match.params.walkId] || entityDefaultState;

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadWalk,
	loadPartyInfo,
	loadDogInfo,
	loadGeneralEnum,
	resetEntity,
	resetPage,
	showModal
})(WalkDetailPage)



// WEBPACK FOOTER //
// ./src/containers/WalkDetailPage.js